// extracted by mini-css-extract-plugin
export default {"static":"Static-module__static__PuzqR2W"};